import { ApiProperty } from "@nestjs/swagger";

export class SaleOrderProductIdRequest{
    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()
    productId: number;
    
    @ApiProperty()
    plantId: number;

    @ApiProperty()
    count?: number;
}